import React from 'react'
import { NavLink } from 'react-router-dom'

interface MobileMenuLinkProps {
  children: React.ReactNode
  to: string
}

function MobileMenuLink({ children, to }: MobileMenuLinkProps) {
  return (
    <NavLink
      activeClassName="bg-surface-subtle text-color-strong"
      to={to}
      className="text-color-subtle hover:bg-surface-strong group text-sm flex font-medium px-sm py-xs justify-center w-24"
    >
      {children}
    </NavLink>
  )
}

export { MobileMenuLink }
